
import React from "react";
import classes from "./DisplayMacros.module.css";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function DisplayMacros({ imageList, onCLickAction, fileUploadDestination, macroSourceImg }) {

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');


    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <div>
            <div className={classes.button__holder} 
             onClick={handleClickOpen('paper')}>
                <img className={classes.macro__image}
                    src={macroSourceImg}
                    alt="macro"
                    loading="lazy"
                >
                </img>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Your choice
                <IconButton
                    className={classes.button__container}
                    variant="contained"
                    component="label"
                    color="primary"
                    onClick={handleClose}
                    >
                        <CloseIcon fontSize="medium" />

                    </IconButton>
                
                </DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        className={classes.image__list} 
                    >
                        {
                            imageList.map(url => (
                                <img
                                    src={url}
                                    alt={""}
                                    key={url}
                                    className={classes.image__list__img}
                                    onClick={() => {
                                        onCLickAction(url);
                                        handleClose();
                                    }}
                                />
                            ))
                        }


                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}


